import React from 'react'
import TotalDescargaPorGradoView from '../../components/listados/TotalDescargaPorGradoView'

function TotalDescargaPorGrado () {
  return (
    <TotalDescargaPorGradoView />
  )
}

export default TotalDescargaPorGrado
